import { watch } from 'vue';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { useCategoriesStore } from '@/store/categoriesStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import { extractUrls } from './useExtractUrls';
import { extractCategoryData } from '@/helpers/category/extractCategoryData';

export default function useProcessCategory() {
  const categoriesStore = useCategoriesStore();
  const urlSourcesStore = useUrlSourcesStore();
  const activeUrlStore = useActiveUrlStore();

  watch(
    () => urlSourcesStore.getCategoriesSource,
    (categoriesSource) => {
      const toProcess = categoriesSource.filter(
        (u) => !categoriesStore.hasUrl(u.pathname)
      );

      toProcess.forEach(({ urlSource, pathname }) => {
        extractUrls(urlSource);

        const categoryData = extractCategoryData(
          urlSource,
          pathname,
          activeUrlStore.getProvider,
          urlSourcesStore.getJoinedCategoryHubSources,
          activeUrlStore.activeUrl
        );

        // spread the ICategory object into your store method
        categoriesStore.addCategory(
          categoryData.pathname,
          categoryData.metaTitle,
          categoryData.metaDescription,
          categoryData.name,
          categoryData.images,
          categoryData.productsPaths,
          categoryData.description
        );
      });
    },
    { immediate: true }
  );
}
